/**
 * Prepares a list of order history items from backend data
 *
 * This function transforms raw data received from the backend into a more
 * digestible and structured format suitable for rendering in the user interface.
 * @param {object | null | undefined} backendData - The raw data received from the backend, expected to contain an `items` array.
 * @param {Array<object>} backendData.items - An array of order items, each containing details like `mtsbuCode`, `typeId`, `insurant`, `fullPrice`, and `insuranceObject`.
 * @returns {Array<object>} An array of prepared order history items, each with `id`, `typeId`, `name`, `amount`, and `details` (including `vehicleNumber`). Returns an empty array if `backendData` is null or undefined, or if `backendData.items` is not an array.
 */
export function prepareOrdersHistoryList(backendData) {
  if (!backendData || !Array.isArray(backendData?.items)) {
    return [];
  }

  return backendData.items.map((item) => {
    return {
      id: item?.mtsbuCode || '',
      typeId: item?.typeId || -1,
      name: item?.insurant?.fullName || '',
      amount: item?.discountDetails?.dynamicDiscountPrice || item?.fullPrice || 0,
      details: {
        vehicleNumber: item?.insuranceObject?.number || '',
      }
    };
  });
}
